// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/server.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/compression-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-services_cont {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
  padding: 10px;
}
.home-services_container {
  margin-top: 25px;
}
.home-services_title {
  font-size: 64px;
  font-weight: 700;
  line-height: 70px;
  letter-spacing: 0em;
  text-align: center;
  padding: 3% 0%;
  background-color: #f2f2f7;
  margin-bottom: 0px;
}
@media screen and (max-width: 768px) {
  .home-services_title {
    font-size: 44px;
    line-height: 66px;
  }
}
@media screen and (max-width: 415px) {
  .home-services_title {
    font-size: 36px;
    line-height: 43px;
    padding: 6% 0%;
  }
}
.home-services_top {
  margin: 2% 11%;
  border: 1px solid #fff;
  border-radius: 40px;
  display: flex;
  justify-content: space-around;
  height: 245px;
  align-items: center;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .home-services_top {
    padding: 2% 6%;
  }
}
@media screen and (max-width: 415px) {
  .home-services_top {
    margin: 2% 5%;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 320px;
    padding: 3% 5%;
    gap: 10px;
  }
}
.home-services_part {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 156px;
}
@media screen and (max-width: 415px) {
  .home-services_part img {
    width: 46px;
    height: 46px;
  }
}
.home-services_info-cont {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin: 3% 8%;
}
@media screen and (max-width: 768px) {
  .home-services_info-cont {
    margin: 3% 4%;
  }
}
@media screen and (max-width: 415px) {
  .home-services_info-cont {
    flex-wrap: nowrap;
    overflow: scroll;
    justify-content: start;
  }
}

.services-part_title {
  color: #fff;
  margin: 7px 0px;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
}
@media screen and (max-width: 768px) {
  .services-part_title {
    font-size: 16px;
    font-weight: 700;
  }
}
.services-part_desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #F2F2EA;
}
@media screen and (max-width: 415px) {
  .services-part_desc {
    font-size: 14px;
    line-height: 21px;
  }
}
.services-btn-cont {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 20px;
  background-color: #f2f2f7;
}

.yayin-container {
  display: flex;
  padding: 4% 0%;
  background-color: #f2f2f7;
  justify-content: space-between;
}
@media screen and (max-width: 415px) {
  .yayin-container {
    flex-direction: column;
  }
}
.yayin-text {
  display: inline-block;
  width: 49%;
  padding: 0 10px 0px 2%;
}
@media screen and (max-width: 768px) {
  .yayin-text {
    padding: 0 17px 0px 4%;
  }
}
@media screen and (max-width: 415px) {
  .yayin-text {
    padding: 0% 6%;
    width: 100%;
    margin-bottom: 20px;
  }
}
.yayin-text h4 {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  margin-right: 2%;
  margin-bottom: 25px;
}
@media screen and (max-width: 768px) {
  .yayin-text h4 {
    font-size: 18px;
    line-height: 21.6px;
    margin-bottom: 15px;
  }
}
.yayin-text_desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: #808080;
}
@media screen and (max-width: 415px) {
  .yayin-text_desc {
    font-size: 16px;
    line-height: 24px;
  }
}
.yayin-img {
  width: 50%;
  display: contents;
  object-fit: cover;
}
@media screen and (max-width: 1440px) {
  .yayin-img {
    display: inline-block;
  }
}
@media screen and (max-width: 415px) {
  .yayin-img {
    width: 100%;
    padding-left: 6%;
  }
}
.yayin-img img {
  border-radius: 40px 0px 0px 40px;
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 1440px) {
  .yayin-img img {
    max-height: 607px;
  }
}
@media screen and (max-width: 1024px) {
  .yayin-img img {
    max-height: 619px;
  }
}
@media screen and (max-width: 415px) {
  .yayin-img img {
    height: 518px;
  }
}
.yayin-select-container {
  border: 1px solid #fff;
  border-radius: 20px;
  background-color: #fff;
  padding: 30px;
  width: 47%;
  height: 280px;
  margin-top: 4%;
  position: relative;
  opacity: 0.8;
}
@media screen and (max-width: 768px) {
  .yayin-select-container {
    width: 100%;
    padding: 15px;
    height: auto;
    margin-top: 1%;
  }
}
.yayin-select_top {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}
@media screen and (max-width: 768px) {
  .yayin-select_top {
    flex-direction: row;
    justify-content: start;
    align-items: start;
  }
}
@media screen and (max-width: 415px) {
  .yayin-select_top {
    flex-direction: column;
  }
}
@media screen and (max-width: 415px) {
  .yayin-select-text_cont {
    height: 50px;
  }
}
.yayin-select_text-box {
  margin-top: 25px;
}
@media screen and (max-width: 768px) {
  .yayin-select_text-box {
    margin-top: 0px;
    margin-left: 10px;
    width: calc(100% - 108px);
  }
}
@media screen and (max-width: 415px) {
  .yayin-select_text-box {
    margin-top: 10px;
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .yayin-select_desc {
    text-align: left;
  }
}
.yayin-select_desc span {
  display: block;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
@media screen and (max-width: 768px) {
  .yayin-select_desc span {
    display: inline-block;
    margin-right: 5px;
    font-weight: 700;
    line-height: 15px;
  }
}
@media screen and (max-width: 415px) {
  .yayin-select_desc span {
    display: block;
  }
}
.yayin-select_title {
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  display: block;
  text-align: left;
}
@media screen and (max-width: 768px) {
  .yayin-select_title {
    font-weight: 700;
    line-height: 15px;
  }
}
@media screen and (max-width: 415px) {
  .yayin-select_title {
    font-weight: 600;
  }
}
.yayin-select_mhz {
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  display: block;
  margin-top: 10%;
  margin-bottom: 5px;
}
@media screen and (max-width: 768px) {
  .yayin-select_mhz {
    margin-top: 15px;
    line-height: 12px;
  }
}
@media screen and (max-width: 415px) {
  .yayin-select_mhz {
    margin-top: 5px;
    margin-bottom: 0px;
  }
}

.active-yayin {
  border-color: #FCAF17;
  opacity: 1;
}

#turkey-beam {
  margin-right: 4%;
}

#west-beam {
  margin-right: 2%;
}
@media screen and (max-width: 768px) {
  #west-beam {
    margin-top: 20px;
  }
}

.select-icon {
  position: absolute;
  top: 35px;
  right: 30px;
}
@media screen and (max-width: 768px) {
  .select-icon {
    top: 20px;
    right: 20px;
    width: 28px;
    height: 28px;
  }
}
@media screen and (max-width: 458px) {
  .select-icon {
    width: 20px;
    height: 20px;
  }
}

.compression-container {
  display: flex;
  margin: 4% 0%;
  gap: 4%;
}
@media screen and (max-width: 415px) {
  .compression-container {
    flex-direction: column;
  }
}
.compression_text-box {
  width: 495px;
}
@media screen and (max-width: 768px) {
  .compression_text-box {
    width: 272px;
  }
}
@media screen and (max-width: 415px) {
  .compression_text-box {
    width: 84%;
    margin: 20px 35px;
  }
}
.compression_title {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
}
@media screen and (max-width: 768px) {
  .compression_title {
    font-size: 18px;
    line-height: 21px;
  }
}
.compression_desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  margin-top: 5%;
  color: #757575;
}
@media screen and (max-width: 768px) {
  .compression_desc {
    font-size: 16px;
    line-height: 24px;
  }
}
.compression-img {
  width: 57%;
  height: 350px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right;
  background-size: cover;
  border-radius: 0px 40px 40px 0px;
}
@media screen and (max-width: 1440px) {
  .compression-img {
    height: 323px;
  }
}
@media screen and (max-width: 768px) {
  .compression-img {
    width: 56.5%;
    height: 270px;
  }
}
@media screen and (max-width: 415px) {
  .compression-img {
    width: 95%;
  }
}
.compression-md-show {
  display: none;
}
@media screen and (max-width: 768px) {
  .compression-md-show {
    display: block;
    padding: 0px 30px;
    width: 100%;
  }
}

.carousel {
  height: 337px;
  margin-top: 25px;
}
.carousel-item-next, .carousel-item-prev, .carousel-item.active {
  height: 277px;
  display: flex !important;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}
.carousel .carousel-indicators [data-bs-target] {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border-top: none;
  border-bottom: none;
  color: #F2F2EA;
  opacity: 1;
  margin: 0px 5px;
}
.carousel .carousel-indicators .active {
  width: 41px;
  color: #fff;
  border-radius: 100px;
}

.carousel-item {
  padding: 1px 2%;
}

@media screen and (max-width: 1024px) {
  .yayin-select_title,
  .yayin-select_desc span,
  .yayin-select_mhz {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .yayin-select_desc span,
  .yayin-select_mhz,
  .yayin-select_title {
    font-size: 12px;
  }
}
@media screen and (max-width: 415px) {
  .satellite {
    width: 40px;
    height: 40px;
  }
  .yayin-select_desc span,
  .yayin-select_mhz,
  .yayin-select_title {
    font-size: 10px;
    font-weight: 400;
    line-height: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/HomeServicesComponent.scss"],"names":[],"mappings":"AACI;EACI,oEAAA;EACA,sBAAA;EACA,aAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAFR;AAIQ;EAVJ;IAWQ,eAAA;IACA,iBAAA;EADV;AACF;AAGQ;EAfJ;IAgBQ,eAAA;IACA,iBAAA;IACA,cAAA;EAAV;AACF;AAGI;EACI,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;UAAA,0BAAA;EACA,8BAAA;AADR;AAGQ;EAXJ;IAYQ,cAAA;EAAV;AACF;AAEQ;EAfJ;IAgBQ,aAAA;IACA,eAAA;IACA,6BAAA;IACA,aAAA;IACA,cAAA;IACA,SAAA;EACV;AACF;AAEI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAAR;AAGY;EADJ;IAEQ,WAAA;IACA,YAAA;EAAd;AACF;AAII;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAFR;AAIQ;EAPJ;IAQQ,aAAA;EADV;AACF;AAGQ;EAXJ;IAYQ,iBAAA;IACA,gBAAA;IACA,sBAAA;EAAV;AACF;;AAMI;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHR;AAKQ;EAPJ;IAQQ,eAAA;IACA,gBAAA;EAFV;AACF;AAKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHR;AAKQ;EANJ;IAOQ,eAAA;IACA,iBAAA;EAFV;AACF;AAKI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAHR;;AAQI;EACI,aAAA;EACA,cAAA;EACA,yBAAA;EACA,8BAAA;AALR;AAOQ;EANJ;IAOQ,sBAAA;EAJV;AACF;AAOI;EACI,qBAAA;EACA,UAAA;EACA,sBAAA;AALR;AAOQ;EALJ;IAMQ,sBAAA;EAJV;AACF;AAMQ;EATJ;IAUQ,cAAA;IACA,WAAA;IACA,mBAAA;EAHV;AACF;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAKY;EAPJ;IAQQ,eAAA;IACA,mBAAA;IACA,mBAAA;EAFd;AACF;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAKY;EANJ;IAOQ,eAAA;IACA,iBAAA;EAFd;AACF;AAMI;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AAJR;AAMQ;EALJ;IAMQ,qBAAA;EAHV;AACF;AAKQ;EATJ;IAUQ,WAAA;IACA,gBAAA;EAFV;AACF;AAIQ;EACI,gCAAA;EACA,WAAA;EACA,YAAA;AAFZ;AAIY;EALJ;IAMQ,iBAAA;EADd;AACF;AAGY;EATJ;IAUQ,iBAAA;EAAd;AACF;AAEY;EAbJ;IAcQ,aAAA;EACd;AACF;AAIQ;EACI,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAFZ;AAIY;EAXJ;IAYQ,WAAA;IACA,aAAA;IACA,YAAA;IACA,cAAA;EADd;AACF;AAIQ;EACI,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAFZ;AAIY;EANJ;IAOQ,mBAAA;IACA,sBAAA;IACA,kBAAA;EADd;AACF;AAGY;EAZJ;IAaQ,sBAAA;EAAd;AACF;AAIY;EADJ;IAEQ,YAAA;EADd;AACF;AAIQ;EACI,gBAAA;AAFZ;AAIY;EAHJ;IAIQ,eAAA;IACA,iBAAA;IACA,yBAAA;EADd;AACF;AAGY;EATJ;IAUQ,gBAAA;IACA,WAAA;EAAd;AACF;AAKY;EADJ;IAEQ,gBAAA;EAFd;AACF;AAIY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAFhB;AAIgB;EAPJ;IAQQ,qBAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EADlB;AACF;AAGgB;EAdJ;IAeQ,cAAA;EAAlB;AACF;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAFZ;AAIY;EAPJ;IAQQ,gBAAA;IACA,iBAAA;EADd;AACF;AAGY;EAZJ;IAaQ,gBAAA;EAAd;AACF;AAGQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AADZ;AAGY;EATJ;IAUQ,gBAAA;IACA,iBAAA;EAAd;AACF;AAEY;EAdJ;IAeQ,eAAA;IACA,kBAAA;EACd;AACF;;AAIA;EACI,qBAAA;EACA,UAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;AAGI;EAHJ;IAIQ,gBAAA;EAAN;AACF;;AAGA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAEI;EALJ;IAMQ,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EACN;AACF;AACI;EAZJ;IAaQ,WAAA;IACA,YAAA;EAEN;AACF;;AAGI;EACI,aAAA;EACA,aAAA;EACA,OAAA;AAAR;AAEQ;EALJ;IAMQ,sBAAA;EACV;AACF;AAGI;EACI,YAAA;AADR;AAGQ;EAHJ;IAIQ,YAAA;EAAV;AACF;AAEQ;EAPJ;IAQQ,UAAA;IACA,iBAAA;EACV;AACF;AAEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAAR;AAEQ;EALJ;IAMQ,eAAA;IACA,iBAAA;EACV;AACF;AAEI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAAR;AAEQ;EAPJ;IAQQ,eAAA;IACA,iBAAA;EACV;AACF;AAEI;EACI,UAAA;EACA,aAAA;EACA,mEAAA;EACA,sBAAA;EACA,gCAAA;AAAR;AAEQ;EAPJ;IAQQ,aAAA;EACV;AACF;AACQ;EAXJ;IAYQ,YAAA;IACA,aAAA;EAEV;AACF;AAAQ;EAhBJ;IAiBQ,UAAA;EAGV;AACF;AAAI;EACI,aAAA;AAER;AAAQ;EAHJ;IAIQ,cAAA;IACA,iBAAA;IACA,WAAA;EAGV;AACF;;AACA;EACI,aAAA;EACA,gBAAA;AAEJ;AAAI;EAGI,aAAA;EACA,wBAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;AAAR;AAIQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AAFZ;AAKQ;EACI,WAAA;EACA,WAAA;EACA,oBAAA;AAHZ;;AAQA;EACI,eAAA;AALJ;;AAQA;EAEI;;;IAGI,eAAA;EANN;AACF;AASA;EAEI;;;IAGI,eAAA;EARN;AACF;AAWA;EACI;IACI,WAAA;IACA,YAAA;EATN;EAYE;;;IAGI,eAAA;IACA,gBAAA;IACA,iBAAA;EAVN;AACF","sourcesContent":[".home-services {\n    &_cont {\n        background: url(\"../../assets/images/server.png\") no-repeat center;\n        background-size: cover;\n        padding: 10px;\n    }\n\n    &_container {\n        margin-top: 25px;\n    }\n\n    &_title {\n        font-size: 64px;\n        font-weight: 700;\n        line-height: 70px;\n        letter-spacing: 0em;\n        text-align: center;\n        padding: 3% 0%;\n        background-color: #f2f2f7ff;\n        margin-bottom: 0px;\n\n        @media screen and (max-width: 768px) {\n            font-size: 44px;\n            line-height: 66px;\n        }\n\n        @media screen and (max-width: 415px) {\n            font-size: 36px;\n            line-height: 43px;\n            padding: 6% 0%;\n        }\n    }\n\n    &_top {\n        margin: 2% 11%;\n        border: 1px solid #fff;\n        border-radius: 40px;\n        display: flex;\n        justify-content: space-around;\n        height: 245px;\n        align-items: center;\n        backdrop-filter: blur(4px);\n        background: rgba(0, 0, 0, 0.2);\n\n        @media screen and (max-width: 768px) {\n            padding: 2% 6%;\n        }\n\n        @media screen and (max-width: 415px) {\n            margin: 2% 5%;\n            flex-wrap: wrap;\n            justify-content: space-around;\n            height: 320px;\n            padding: 3% 5%;\n            gap: 10px;\n        }\n    }\n\n    &_part {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        min-height: 156px;\n\n        img {\n            @media screen and (max-width: 415px) {\n                width: 46px;\n                height: 46px;\n            }\n        }\n    }\n\n    &_info-cont {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 10px;\n        margin: 3% 8%;\n\n        @media screen and (max-width: 768px) {\n            margin: 3% 4%;\n        }\n\n        @media screen and (max-width: 415px) {\n            flex-wrap: nowrap;\n            overflow: scroll;\n            justify-content: start;\n        }\n\n    }\n}\n\n.services {\n    &-part_title {\n        color: #fff;\n        margin: 7px 0px;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n\n        @media screen and (max-width: 768px) {\n            font-size: 16px;\n            font-weight: 700;\n        }\n    }\n\n    &-part_desc {\n        font-size: 16px;\n        font-weight: 400;\n        line-height: 24px;\n        color: #F2F2EA;\n\n        @media screen and (max-width: 415px) {\n            font-size: 14px;\n            line-height: 21px;\n        }\n    }\n\n    &-btn-cont {\n        display: flex;\n        justify-content: center;\n        margin-top: 20px;\n        padding: 20px;\n        background-color: #f2f2f7ff;\n    }\n}\n\n.yayin {\n    &-container {\n        display: flex;\n        padding: 4% 0%;\n        background-color: #f2f2f7ff;\n        justify-content: space-between;\n\n        @media screen and (max-width: 415px) {\n            flex-direction: column;\n        }\n    }\n\n    &-text {\n        display: inline-block;\n        width: 49%;\n        padding: 0 10px 0px 2%;\n\n        @media screen and (max-width: 768px) {\n            padding: 0 17px 0px 4%;\n        }\n\n        @media screen and (max-width: 415px) {\n            padding: 0% 6%;\n            width: 100%;\n            margin-bottom: 20px;\n        }\n\n        h4 {\n            font-size: 32px;\n            font-weight: 700;\n            line-height: 40px;\n            margin-right: 2%;\n            margin-bottom: 25px;\n\n            @media screen and (max-width: 768px) {\n                font-size: 18px;\n                line-height: 21.6px;\n                margin-bottom: 15px;\n            }\n        }\n\n        &_desc {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 27px;\n            color: #808080;\n\n            @media screen and (max-width: 415px) {\n                font-size: 16px;\n                line-height: 24px;\n            }\n        }\n    }\n\n    &-img {\n        width: 50%;\n        display: contents;\n        object-fit: cover;\n\n        @media screen and (max-width: 1440px) {\n            display: inline-block;\n        }\n\n        @media screen and (max-width: 415px) {\n            width: 100%;\n            padding-left: 6%;\n        }\n\n        img {\n            border-radius: 40px 0px 0px 40px;\n            width: 100%;\n            height: 100%;\n\n            @media screen and (min-width: 1440px) {\n                max-height: 607px;\n            }\n\n            @media screen and (max-width: 1024px) {\n                max-height: 619px;\n            }\n\n            @media screen and (max-width: 415px) {\n                height: 518px;\n            }\n        }\n    }\n\n    &-select {\n        &-container {\n            border: 1px solid #fff;\n            border-radius: 20px;\n            background-color: #fff;\n            padding: 30px;\n            width: 47%;\n            height: 280px;\n            margin-top: 4%;\n            position: relative;\n            opacity: .8;\n\n            @media screen and (max-width: 768px) {\n                width: 100%;\n                padding: 15px;\n                height: auto;\n                margin-top: 1%;\n            }\n        }\n\n        &_top {\n            display: flex;\n            justify-content: flex-start;\n            flex-direction: column;\n            align-items: flex-start;\n\n            @media screen and (max-width: 768px) {\n                flex-direction: row;\n                justify-content: start;\n                align-items: start;\n            }\n\n            @media screen and (max-width: 415px) {\n                flex-direction: column;\n            }\n        }\n\n        &-text_cont {\n            @media screen and (max-width: 415px) {\n                height: 50px;\n            }\n        }\n\n        &_text-box {\n            margin-top: 25px;\n\n            @media screen and (max-width: 768px) {\n                margin-top: 0px;\n                margin-left: 10px;\n                width: calc(100% - 108px);\n            }\n\n            @media screen and (max-width: 415px) {\n                margin-top: 10px;\n                width: 100%;\n            }\n\n        }\n\n        &_desc {\n            @media screen and (max-width: 768px) {\n                text-align: left;\n            }\n\n            span {\n                display: block;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                text-align: left;\n\n                @media screen and (max-width: 768px) {\n                    display: inline-block;\n                    margin-right: 5px;\n                    font-weight: 700;\n                    line-height: 15px;\n                }\n\n                @media screen and (max-width: 415px) {\n                    display: block;\n                }\n            }\n        }\n\n        &_title {\n            font-size: 16px;\n            font-weight: 500;\n            line-height: 26px;\n            display: block;\n            text-align: left;\n\n            @media screen and (max-width: 768px) {\n                font-weight: 700;\n                line-height: 15px;\n            }\n\n            @media screen and (max-width: 415px) {\n                font-weight: 600;\n            }\n        }\n\n        &_mhz {\n            font-size: 15px;\n            font-weight: 600;\n            line-height: 20px;\n            text-align: left;\n            display: block;\n            margin-top: 10%;\n            margin-bottom: 5px;\n\n            @media screen and (max-width: 768px) {\n                margin-top: 15px;\n                line-height: 12px;\n            }\n\n            @media screen and (max-width: 415px) {\n                margin-top: 5px;\n                margin-bottom: 0px;\n            }\n        }\n    }\n}\n\n.active-yayin {\n    border-color: #FCAF17;\n    opacity: 1;\n}\n\n#turkey-beam {\n    margin-right: 4%;\n}\n\n#west-beam {\n    margin-right: 2%;\n\n    @media screen and (max-width: 768px) {\n        margin-top: 20px;\n    }\n}\n\n.select-icon {\n    position: absolute;\n    top: 35px;\n    right: 30px;\n\n    @media screen and (max-width: 768px) {\n        top: 20px;\n        right: 20px;\n        width: 28px;\n        height: 28px;\n    }\n\n    @media screen and (max-width: 458px) {\n        width: 20px;\n        height: 20px;\n\n    }\n}\n\n.compression {\n    &-container {\n        display: flex;\n        margin: 4% 0%;\n        gap: 4%;\n\n        @media screen and (max-width: 415px) {\n            flex-direction: column;\n        }\n\n    }\n\n    &_text-box {\n        width: 495px;\n\n        @media screen and (max-width: 768px) {\n            width: 272px;\n        }\n\n        @media screen and (max-width: 415px) {\n            width: 84%;\n            margin: 20px 35px;\n        }\n    }\n\n    &_title {\n        font-size: 32px;\n        font-weight: 700;\n        line-height: 40px;\n\n        @media screen and (max-width: 768px) {\n            font-size: 18px;\n            line-height: 21px;\n        }\n    }\n\n    &_desc {\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 27px;\n        margin-top: 5%;\n        color: #757575;\n\n        @media screen and (max-width: 768px) {\n            font-size: 16px;\n            line-height: 24px;\n        }\n    }\n\n    &-img {\n        width: 57%;\n        height: 350px;\n        background: url('../../assets/images/compression-img.png') no-repeat right;\n        background-size: cover;\n        border-radius: 0px 40px 40px 0px;\n\n        @media screen and (max-width: 1440px) {\n            height: 323px;\n        }\n\n        @media screen and (max-width: 768px) {\n            width: 56.5%;\n            height: 270px;\n        }\n\n        @media screen and (max-width: 415px) {\n            width: 95%;\n        }\n    }\n\n    &-md-show {\n        display: none;\n\n        @media screen and (max-width: 768px) {\n            display: block;\n            padding: 0px 30px;\n            width: 100%;\n        }\n    }\n}\n\n.carousel {\n    height: 337px;\n    margin-top: 25px;\n\n    &-item-next,\n    &-item-prev,\n    &-item.active {\n        height: 277px;\n        display: flex !important;\n        flex-wrap: wrap;\n        gap: 10px;\n        justify-content: space-between;\n    }\n\n    .carousel-indicators {\n        [data-bs-target] {\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            border-top: none;\n            border-bottom: none;\n            color: #F2F2EA;\n            opacity: 1;\n            margin: 0px 5px;\n        }\n\n        .active {\n            width: 41px;\n            color: #fff;\n            border-radius: 100px;\n        }\n    }\n}\n\n.carousel-item {\n    padding: 1px 2%;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .yayin-select_title,\n    .yayin-select_desc span,\n    .yayin-select_mhz {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .yayin-select_desc span,\n    .yayin-select_mhz,\n    .yayin-select_title {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 415px) {\n    .satellite {\n        width: 40px;\n        height: 40px;\n    }\n\n    .yayin-select_desc span,\n    .yayin-select_mhz,\n    .yayin-select_title {\n        font-size: 10px;\n        font-weight: 400;\n        line-height: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
